import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ContactScreenService {
    open$: Subject<any> = new Subject<any>();
}
